import { LoginAdapters, LoginCertificadoAdapters, ResetEmailAdapters, TokenAdapters } from "../adapters/auth.adapters"
import { useAxios } from "../../hooks/useAxios"

const LoginServices = {

    POST: function () {

        return useAxios({ method: 'post', url: '/auth/usuarios-ebcn', type: 'json', adapters: LoginAdapters.POST })
    }
}

// Login con certificado digital.
//
// La petición NO va a la API: va a `public/valida/index.php`, el proxy PHP que recoge el
// certificado de cliente del handshake TLS. El handshake lo hace el vhost que sirve el front,
// no el de la API, así que la url tiene que apuntar a la raíz del front y ser absoluta: si es
// relativa, `axios.defaults.baseURL` (`src/index.tsx`, que apunta a REACT_APP_API_URL) la
// prefija y la petición acaba en Laravel (p.ej. `/ebcnservices/ebcnbackoffice/valida/`).
//
// `PUBLIC_URL` es la base del front, pero su forma depende del entorno: al compilar CRA la
// deja tal cual (`.env.production` y `.env.devarescoop` la definen como url absoluta) y en
// desarrollo la reduce a su pathname vía `getPublicUrlOrPath` de react-scripts (ver
// `.env.development`: `https://desarrollo.arescoop.es/ebcnbackoffice` -> `/ebcnbackoffice/`).
// Ese pathname hay que completarlo con el origen del front; si no, quedaría relativo y axios
// lo prefijaría con el baseURL de la API.
const frontBaseUrl = (() => {

    const publicUrl = (process.env.PUBLIC_URL || '').replace(/\/+$/, '')

    if (!publicUrl || publicUrl === '.') return window.location.origin
    if (/^https?:\/\//i.test(publicUrl)) return publicUrl

    return `${window.location.origin}${publicUrl}`
})()

// Se llama al fichero `.php` explícito (`/valida/index.php`), no a la carpeta (`/valida/`).
// El `.htaccess` del front sólo descarta ficheros existentes:
//
//     RewriteCond %{REQUEST_FILENAME} !-f
//     RewriteRule ^ index.html [QSA,L]
//
// Con `/valida/` el `REQUEST_FILENAME` es un directorio, la condición se cumple y la petición
// acaba en el `index.html` de la SPA (el "You need to enable JavaScript to run this app.").
// Pidiendo el `.php`, `!-f` no se cumple y Apache lo ejecuta. Es la misma convención que usan
// los otros PHP de `public/` (`/elecciones/elecciones.php`, `/docsEBCN/leerfichero.php`...).
const LoginCertificadoServices = {

    POST: function () {

        return useAxios({
            method: 'post',
            url: `${frontBaseUrl}/valida/index.php`,
            type: 'json',
            adapters: LoginCertificadoAdapters.POST
        })
    }
}

const TokenServices = {

    POST: function () {

        return useAxios({ method: 'post', url: '/auth/validate', type: 'json', adapters: TokenAdapters.POST })
    }
}

const ResetEmailServices = {

    GET: function () {

        return useAxios({ method: 'get', url: 'users/usuarios-ebcn/reset-email', type: 'json', adapters: ResetEmailAdapters.GET })
    },

    POST: function () {

        return useAxios({ method: 'post', url: '/users/usuarios-ebcn/reset-email', type: 'json', adapters: ResetEmailAdapters.POST })
    }
}

export {
    LoginServices,
    LoginCertificadoServices,
    ResetEmailServices,
    TokenServices
}